import { Navigate } from "react-router-dom"
import useIsAdminRoute from "hooks/useAdminRoute"
export const isAdminRoute = () => {
  return window.location.pathname.split("/").includes("admin")
}

export const ToUserOrAdminLogin = () => {
  const isAdminRoute = useIsAdminRoute()

  if (isAdminRoute) return <Navigate to="/admin/login" replace />
  return <Navigate to="/login" replace />
}

export const imageUrlBuilder = (url) => {
  return process.env.REACT_APP_APIURL + "/images/" + url
}
export const SOURCEOBJ = {
  healthgrades: "healthgrades",
  google: "google",
  medpromotor: "medpromotor",
}
export const reviewUrlBuilder = (source, slug) => {
  if (!slug) return "";
  switch (source) {
    case SOURCEOBJ.google: {
      if (slug && (slug.startsWith("http://") || slug.startsWith("https://"))) {
        return slug;
      }
      return "https://search.google.com/local/writereview?placeid=" + slug
    }
  }
}

export const apiUrl = process.env.REACT_APP_APIURL
